/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Admin_Status_PrintedInputs */

const vi_print_admin_status_printed = /** @type {(inputs: Print_Admin_Status_PrintedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã in`)
};

/**

* @param {Print_Admin_Status_PrintedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_admin_status_printed = /** @type {((inputs?: Print_Admin_Status_PrintedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Admin_Status_PrintedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_admin_status_printed(inputs)
});